import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
})
export class NumberFormatPipe implements PipeTransform {

  transform(number: number, arg: boolean): any {
    if (arg) {
      return number.toString().replace(',', '');
    } else {
      return number;
    }
  }
}
